export enum AssessmentSurveyType {
  MAP = "MAP",
  MATCH_V_V2 = "MATCH_V_V2",
  AP_COMPETENCIES = "AP_COMPETENCIES",
  IPIP_NEO_BIG_5 = "IPIP_NEO_BIG_5",
  SHWARTZ_VALUES = "SHWARTZ_VALUES",
  WISNIO_COMPETENCIES = "WISNIO_COMPETENCIES",
}

export const ASSESSMENT_SURVEY_TYPES = [
  AssessmentSurveyType.MAP,
  AssessmentSurveyType.MATCH_V_V2,
  AssessmentSurveyType.AP_COMPETENCIES,
  AssessmentSurveyType.IPIP_NEO_BIG_5,
  AssessmentSurveyType.SHWARTZ_VALUES,
  AssessmentSurveyType.WISNIO_COMPETENCIES,
];

export enum AssessmentSurveyGroup {
  WISNIO = "WISNIO_SURVEYS",
  AP = "ASSESSIO_SURVEYS",
}

export interface AssessmentSurveyConfig {
  type: AssessmentSurveyType;
  group: AssessmentSurveyGroup;
}

// Category type enum for normalized dimension group names
export enum DimensionCategoryType {
  PERSONALITY = "personality",
  VALUES = "values",
  COMPETENCIES = "competencies",
}
